<template lang="pug">

section.src-components-resumen-caja
  h3 Caja Nro {{$store.state.caja.NROTURNO}} desde {{$formatDate($store.state.caja.fechaapertura)}} {{$formatTime($store.state.caja.horaapertura)}} hasta {{$formatDate($store.state.caja.fechacierre)}} {{$formatTime($store.state.caja.horacierre)}}

  v-simple-table
    thead
      tr
        td Fecha
        td Hora
        td Transaccion
        td Medio
        td Debe
        td Haber
        td Saldo
    tbody
      tr(v-for="(item,index) of datos" :key="index")
        td {{ item.fecha }}
        td {{ item.hora }}
        td {{ item.transaccion }}
        td {{ item.medio }}
        td {{ item.debe }}
        td {{ item.haber }}
        td {{ item.saldo }}

</template>

<script lang="js">
  import {Ventas} from "../db/Ventas"

  export default  {
    name: 'src-components-resumen-caja',
    props: ['caja'],
    mounted () {
      this.getCajas()
    },
    data () {
      return {
        dbventas:Ventas(this),
        datos:[], 
        loading:false,
      }
    },
    methods: {
      getCajas() {
        this.datos = []
        /*window.ipcRenderer.invoke('getCaja',this.caja.Idsesion).then((ret)=>{
          this.datos = ret
        }).catch((err)=>{alert(err)})*/
        this.getVentas();
      },
      getVentas() {
        this.expanded = []
        this.loading = true
        this.dbventas.getDetalleCajaVentas(this.$store.state.caja.Idsesion).then((ret) => {
          ret.data.forEach((row) => {
            this.datos.push({
              fecha:"",
              hora:"",
              transaccion:"Venta",
              medio:row.NombreArticulo,
              debe: row.importe*-1,
              haber: 0 ,
              saldo: row.importe*-1,
            })
          })

        }).catch((err) => {alert(err)})
        .finally(() => {
          this.loading = false
        });
      },   
      print() {
      }
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-components-resumen-caja {

  }
</style>
